export default function EFArrowTop(props: any) {
    return (
        <svg width="16px" height="5px" viewBox="0 0 16 5" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="CSR社会貢献" transform="translate(-717.000000, -4472.000000)" fill="#FFFFFF" fillRule="nonzero">
                    <g id="编组-28" transform="translate(0.000000, 4092.000000)">
                        <g id="编组-23" transform="translate(527.000000, 0.000000)">
                            <g id="编组-26" transform="translate(0.000000, 354.000000)">
                                <g id="编组-11" transform="translate(20.000000, 11.000000)">
                                    <g id="编组-2" transform="translate(170.000000, 5.000000)">
                                        <path
                                            d="M14.8934063,10.1950698 C15.36179,10.2061386 15.7388614,10.58321 15.75,11.0575 C15.75,13.0751183 14.3854397,14.7507997 12.6021211,14.9628156 L12.4161848,14.9794811 L12.23,14.985 L3.77,14.985 C1.82124499,14.985 0.250069779,13.2249074 0.250069779,11.0515937 C0.261138557,10.58321 0.638210034,10.2061386 1.11840632,10.1950698 C1.58678997,10.2061386 1.96386144,10.58321 1.975,11.0575 C1.975,12.1676951 2.6393991,13.0763186 3.50239927,13.2347486 L3.64024496,13.2534496 L3.77,13.26 L12.23,13.26 C13.218011,13.26 14.025,12.2851738 14.0250698,11.0515937 C14.0352871,10.6192395 14.3573647,10.2646899 14.7752511,10.2039962 L14.8934063,10.1950698 Z"
                                            id="路径2"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
